var img = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='4' y='4' width='16' height='16' rx='8' fill='%23DA4343'/%3e%3cpath d='M12.9033 15H11.7217V9.29199L9.97852 9.8877V8.88672L12.752 7.86621H12.9033V15Z' fill='white'/%3e%3c/svg%3e";
  var BadgesColored = img;

export { BadgesColored as default };
